// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import the vue instance
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import deviceQueries from './plugins/device-queries'
import Pace from 'pace-progress'
import axios from 'axios'
import VueCookie from 'vue-cookie';
import BackendService from "./services/backend-services"
import VueCarousel from 'vue-carousel';

Vue.component(VueCarousel);
Vue.use(VueRouter)
Vue.use(VueCookie)

import Main from './components/Main.vue'
import Blog from './components/Blog.vue'
import Policy from './components/Policy.vue'

//define your routes
const routes = [
    //route for the home route of the web page
    { path: window.location.pathname, component: Main },
    {path: '/blog', name: 'feed',component: Blog},
    {path: '/blog/read/:post', name: 'post', props: true, component: Blog},
    { path: '/policy', component: Policy },
]

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    routes, // short for routes: routes
    mode: 'history'
})

// Set default value
Vue.prototype.$productStoreId = "aws";
Vue.prototype.$language = "en";
const backendService = new BackendService();
Vue.prototype.$backendService = backendService;

//const website
Vue.use(deviceQueries, {
    phone: 'max-width: 567px',
    tablet: 'min-width: 568px',
    mobile: 'max-width: 1024px',
    laptop: 'min-width: 1025px',
    desktop: 'min-width: 1280px',
    monitor: 'min-width: 1448px'
})
//instatinat the vue instance
new Vue({
    //define the selector for the root component
    el: '#app',
    //pass the template to the root component
    template: '<App/>',
    //declare components that the root component can access
    components: { App },
    //pass in the router to the Vue instance
    router,
    render: h => h(App),
    mounted() {
     Pace.start()
        Pace.on('hide', () => {
            document.dispatchEvent(new Event('app.rendered'));
        })
    }
}).$mount('#app')//mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js